import dayjs from "dayjs";

export const DEPOSIT_MOVEMENT_LABELS = {
    collected: "Collected",
    applied: "Applied",
    refunded: "Refunded",
    forfeited: "Forfeited",
    reversed: "Reversal",
};

export const DEPOSIT_MOVEMENT_LABELS_EMPLOYEE = {
    collected: "Collected from you",
    applied: "Used against dues",
    refunded: "Refunded to you",
    forfeited: "Kept by the organisation",
    reversed: "Correction",
};

export const depositMoney = (value) =>
    Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatDepositTxnType = (txnType, employeeView = false) => {
    const labels = employeeView ? DEPOSIT_MOVEMENT_LABELS_EMPLOYEE : DEPOSIT_MOVEMENT_LABELS;
    return labels[txnType] || (txnType ? String(txnType).replace(/_/g, " ") : "Movement");
};

export const formatDepositTraceLine = (detail) => {
    if (!detail) return null;
    const parts = [
        `#${detail.id}`,
        formatDepositTxnType(detail.txn_type),
        detail.txn_date ? dayjs(detail.txn_date).format("DD-MM-YYYY") : null,
        `₹ ${depositMoney(detail.amount)}`,
    ].filter(Boolean);
    if (detail.reference) {
        parts.push(`Ref: ${detail.reference}`);
    }
    return parts.join(" · ");
};

/**
 * Human-readable movement label plus reversal/refund trace lines for statement tables.
 */
export const getDepositMovementTrace = (txn, { employeeView = false } = {}) => {
    const lines = [];
    const primaryLabel = formatDepositTxnType(txn?.txn_type, employeeView);

    if (txn?.txn_type === "reversed" && txn.reverses_detail) {
        lines.push({
            tone: "muted",
            text: `Corrects ${formatDepositTraceLine(txn.reverses_detail)}`,
        });
    } else if (txn?.txn_type === "refunded") {
        lines.push({
            tone: "muted",
            text: txn.reason || "Refund paid from held deposit balance",
        });
    } else if (txn?.is_reversed && txn.reversed_by_detail) {
        const rev = txn.reversed_by_detail;
        lines.push({
            tone: "warning",
            text: `Reversed by correction #${rev.id}${
                rev.txn_date ? ` · ${dayjs(rev.txn_date).format("DD-MM-YYYY")}` : ""
            }`,
        });
    } else if (txn?.reverses_detail) {
        lines.push({
            tone: "muted",
            text: `Linked to ${formatDepositTraceLine(txn.reverses_detail)}`,
        });
    }

    return { primaryLabel, lines };
};
